import { useCallback, useEffect, useState } from 'react';
import { ProfessionalAreaService } from '../../services/professional-area/professionalAreaService';

const useProfessionalAreas = (initialFilters = {}) => {
    const [data, setData] = useState<any[]>([]);
    const [filters, setFilters] = useState({
        limit: 999999,
        filter_filters: { ...initialFilters }
    });

    const fetchProfessionalAreas = async (extraFilters: any = null) => {
        try {
            const service = new ProfessionalAreaService();
            const response = await service.listForSelect(extraFilters ?? filters);
            const fetchedData = response.getResponseData()?.data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((item: { id: string; name: string; code: string }) => ({
                    value: item.id,
                    label: `${item.code} - ${item.name}`,
                    code: item.code,
                    name: item.name,
                }));
                setData(mappedData);
            } else {
                setData([]);
            }
        } catch (error) {
            console.log('Error fetching professional areas:', error);
            setData([]);
        }
    };

    useEffect(() => {
        fetchProfessionalAreas();
    }, [filters]);

    const updateProfessionalAreasHookFilters = useCallback((newFilters: any) => {
        setFilters((prevFilters: any) => ({
            ...prevFilters,
            filter_filters: {
                ...(prevFilters?.filter_filters ?? {}),
                ...newFilters,
            }
        }));
    }, []);

    const getProfessionalAreasList = () => data;

    return { fetchProfessionalAreas, getProfessionalAreasList, updateProfessionalAreasHookFilters };
}

export default useProfessionalAreas;

